/**
 * Helpers for safely rendering admin-authored rich-text (house rules, widget
 * notes, etc.) that is injected via dangerouslySetInnerHTML.
 *
 * Content is frequently pasted from Word / PDF / email, which introduces:
 *   - non-breaking spaces (U+00A0 / &nbsp; / &#160;) that glue adjacent words
 *     into one long unbreakable token, forcing the browser to break MID-WORD
 *     (e.g. "guar antee") when the token reaches the end of a line;
 *   - soft hyphens, zero-width spaces/joiners and <wbr> that create invisible
 *     break points inside words;
 *   - inline styles like `white-space:nowrap` or `word-break:break-all` that
 *     override our stylesheet and break or overflow the layout.
 *
 * normalizeNoteHtml() neutralises all of the above so the text wraps cleanly
 * between words and never spills outside its container. Mirrors the membership
 * widget's sanitizeInfoHtml so every rich-text surface behaves the same.
 */
export const normalizeNoteHtml = (html) => {
  if (!html || typeof html !== 'string') return html;
  return html
    // non-breaking spaces (entities + the literal chars: U+00A0, U+202F, U+2007)
    .replace(/&nbsp;|&#160;|&#xA0;/gi, ' ')
    .replace(/[   ]/g, ' ')
    // soft hyphen (&shy; / U+00AD) -> remove (invisible break point)
    .replace(/&shy;|&#173;/gi, '')
    .replace(/­/g, '')
    // zero-width space / non-joiner / joiner / word-joiner / BOM -> remove
    .replace(/[​‌‍⁠﻿]/g, '')
    // explicit word-break hints from pasted content -> remove
    .replace(/<wbr\s*\/?>/gi, '')
    // inline styles that override our wrapping rules -> neutralise
    .replace(/white-space\s*:\s*nowrap/gi, 'white-space:normal')
    .replace(/word-break\s*:\s*break-all/gi, 'word-break:normal');
};

export default normalizeNoteHtml;
